import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { GenerateProposalDocumentsClientResponse } from '../@types/GenerateProposalDocuments'

type Store = {
  generateProposalDocuments: GenerateProposalDocumentsClientResponse | null
  setGenerateProposalDocuments: (
    value: GenerateProposalDocumentsClientResponse,
  ) => void
  isGenerateProposalDocuments: boolean
  setIsGenerateProposalDocuments: (value: boolean) => void
}

export const useGenerateProposalDocumentsStore = create<Store>()(
  devtools(
    (set) => ({
      generateProposalDocuments: null,
      setGenerateProposalDocuments: (generateProposalDocuments) =>
        set({ generateProposalDocuments }),
      isGenerateProposalDocuments: false,
      setIsGenerateProposalDocuments: (isGenerateProposalDocuments) =>
        set({ isGenerateProposalDocuments }),
    }),
    { name: 'generateProposalDocumentsStore' },
  ),
)
